<!--
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：ホーム画面
 *
 * 作成者：2021/11/23 ノア）虞
 * 最終修正者：2021/11/23 ノア）虞
 *
 -->
<template>
  <div class="container">
    <div class="body">
      <tti-header></tti-header>
      <tti-silder-bar></tti-silder-bar>
      <tti-audio></tti-audio>
      <div class="content">
        <router-view></router-view>
      </div>
      <update-password></update-password>
      <mfa-set></mfa-set>
      <homeScreens></homeScreens>
      <homeCC></homeCC>
      <home-fav></home-fav>
      <home-notifications></home-notifications>
      <home-notifications-send></home-notifications-send>
      <home-message-send></home-message-send>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

import TtiAudio from '@/components/audio/TtiAudio.vue'
import TtiHeader from '@/components/Header.vue'
import TtiSilderBar from '@/components/SilderBar.vue'
import UpdatePassword from '@/components/UpdatePassword.vue'
import MfaSet from '@/components/MfaSet.vue'
import HomeScreens from '@/views/home/HOME_SCREENS.vue'
import HomeCC from '@/views/home/HOME_CC.vue'
import HomeFav from '@/views/home/HOME_FAV.vue'
import HomeNotifications from '@/views/home/HOME_NOTIFICATIONS.vue'
import HomeNotificationsSend from '@/views/home/HOME_NOTIFICATIONS_SEND.vue'
import HomeMessageSend from '@/views/home/HOME_MESSAGE_SEND.vue'
import mqttUtils from '@/utils/mqttUtils'
import { localService } from '@/commons/services/localService'
import { common } from '@/store/modules'
import { getMQTTConfig } from '@/store/apis'

@Component({
  name: 'Home',
  components: {
    TtiHeader,
    TtiSilderBar,
    TtiAudio,
    UpdatePassword,
    MfaSet,
    HomeScreens,
    HomeCC,
    HomeFav,
    HomeNotifications,
    HomeNotificationsSend,
    HomeMessageSend
  }
})
export default class Home extends Vue {
  /**
   * 企業コード
   */
  companyCode = localService.userInfo?.companyCode || ''

  /**
   * mqttを手動で閉
   */
  doCloseFlag = false

  /**
   * インスタンスがマウントされたちょうど後にフック処理
   *
   * @returns {void}
   */
  mounted(): void {
    this.$log.debug('Home > mounted')
    this.mqttConnect()
    this.doCloseFlag = false
  }

  destroyed(): void {
    this.closeMqtt()
  }

  /**
   * mqtt切断する
   */
  closeMqtt(): void {
    mqttUtils.end()
    this.doCloseFlag = true
  }

  /**
   * mqtt接続
   *
   * @returns {void}
   */
  async mqttConnect(): Promise<void> {
    const topics = [
      this.companyCode + '/status',
      this.companyCode + '/notification',
      this.companyCode + '/announce',
      this.companyCode + '/message'
    ]

    const mqttConfig = await getMQTTConfig()
    mqttUtils.initMqttConfig(mqttConfig)

    mqttUtils.connect(topics, () => {
      this.$log.debug('MQTT > connect: success')
    })

    mqttUtils.onError(() => {
      this.$log.debug('MQTT > connect: error')
      this.$log.warn('MQTT > connect: error')
    })

    mqttUtils.on(this.companyCode + '/status', message => {
      common.setManagementItem(message)
    })

    mqttUtils.on(this.companyCode + '/notification', message => {
      common.setNotificationsData(message)
    })

    mqttUtils.on(this.companyCode + '/message', message => {
      common.setMessageData(message)
    })

    mqttUtils.on(this.companyCode + '/announce', message => {
      common.setAnnounceData(message)
    })
  }
}
</script>

<style scoped lang="scss">
.container {
  width: 100vw;
  height: 100vh;
  overflow-y: hidden;
  overflow-x: auto;
}

.body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  min-width: 1650px;
}

.content {
  position: relative;
  width: 100%;
  height: calc(100vh - 48px);
}
</style>
